<template>
  <div
    :class="[
      $style.notificationItemTransaction,
      { [$style.notificationHeader]: !isNotificationPage },
    ]"
    :data-readed="notification.readed"
    gtmid="NotificationsOpen"
    @click="openModal"
  >
    <ItemWrapper
      :notification="notification"
      :is-notification-page="isNotificationPage"
      :class="$style.notificationItemTransactionWrapper"
    >
      <template #icon>
        <img v-if="notification.data.icon" :src="notification.data.icon.url" />
      </template>
      <template #rightSide>
        <span :class="[$style.notificationItemStatus, notification.data.statusId]">
          {{ notification.data.status }}
        </span>
        <BitButton
          v-if="isNotificationPage"
          :class="$style.notificationItemButtonHistory"
          type="secondary"
          no-margin
        >
          <template #prependIcon>
            <img src="/images/common/chevron-down.svg?url_encode" alt="" />
          </template>
          {{ transactionHistoryButton }}
        </BitButton>
      </template>
    </ItemWrapper>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { computed } from 'vue';
import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreMenuStatuses } from '~/stores/client/menuStatuses';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import ItemWrapper from '../itemWrapper/itemWrapper.vue';
import type { INotificationFeedElement } from '~/types/notifications';

const props = defineProps({
  notification: {
    type: Object as PropType<INotificationFeedElement>,
    required: true,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
});

const storeButtons = useStoreButtonTitles();
const storeModals = useStoreModals();
const storeMenuStatuses = useStoreMenuStatuses();

const transactionHistoryButton = computed(() => storeButtons.transactionHistory);

const openModal = () => {
  storeModals.openModal(props.notification.action.modal, {
    ...props.notification.action?.params,
  });
  storeMenuStatuses.toggleNotificationsMenu(false);
};
</script>

<style lang="scss" module src="./itemTransaction.scss"></style>
